import { Button } from "components/button";
import { InfoTooltip } from "components/InfoTooltip/InfoTooltip";
import { Text } from "components/text";
import type { SalesDataMetricKey } from "hooks/search/salesDataFilterUtils";
import { useTranslation } from "react-i18next";
import { NumericComparisonInput } from "../NumericComparisonInput";

interface SalesDataMetricRowProps {
  metricKey: SalesDataMetricKey;
  label: string;
  id: string;
  hasValue: boolean;
  onClear: () => void;
  max?: number;
  tooltip?: string;
  suffix?: string;
}

export const SalesDataMetricRow = ({
  metricKey,
  label,
  id,
  hasValue,
  onClear,
  max,
  tooltip,
  suffix,
}: SalesDataMetricRowProps) => {
  const { t } = useTranslation(["general"]);

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-1.5">
          <Text as="label" variant="label" htmlFor={id}>
            {label}
          </Text>
          {tooltip && (
            <InfoTooltip
              text={tooltip}
              testId={`${id}-tooltip`}
              iconSize="small"
            />
          )}
        </div>
        {hasValue && (
          <Button
            variant="link"
            size="small"
            label={t("general:buttons.clear")}
            className="p-0 text-xs text-secondary-400 hover:text-secondary-600"
            onClick={onClear}
            testId={`${id}-clear`}
          />
        )}
      </div>
      <NumericComparisonInput
        valueName={`filters.salesData.${metricKey}.value`}
        comparisonName={`filters.salesData.${metricKey}.comparisonOperator`}
        id={id}
        ariaLabel={label}
        max={max}
        suffix={suffix}
        normalizeValue={(value) =>
          value === undefined || value < 0 || (max !== undefined && value > max)
            ? undefined
            : value
        }
      />
    </div>
  );
};
